import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { TextField, Checkbox } from '@material-ui/core'

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectExame = (props) => {
  const exameRealizadoService = useExameRealizadoService()
  const { examesExternos, setExamesExternos, setProcessando, label, isFromBanco, multiplo } = props
  const [listaOpcoesExamesFiltrados, setListaOpcoesExamesFiltrados] = useState([])
  const [processandoOpcoes, setProcessandoOpcoes] = useState(false)
  const [inputExame, setInputExame] = useState(null)

  const fetchExames = useCallback(async (value) => {
    setProcessandoOpcoes(true)
    const response = await exameRealizadoService.filtrarIdentificadoresExamesPeloNumeroLikeString(value)
    setListaOpcoesExamesFiltrados(response)
    setProcessandoOpcoes(false)
  }, [])

  const handleChangeInputExame = useCallback(
    (value) => {
      setInputExame(value)

      if (value?.length > 3) {
        fetchExames(value)
      } else {
        setListaOpcoesExamesFiltrados([])
      }
    },
    [fetchExames]
  )

  return (
    <AutocompleteNative
      value={examesExternos}
      multiple={multiplo}
      name="exameRealizado"
      noOptionsText="Sem informações"
      options={listaOpcoesExamesFiltrados || []}
      onChange={(event, newValue) => {
        setExamesExternos(newValue)
      }}
      getOptionSelected={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => `${option?.numeroExame?.toUpperCase()}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {option?.numeroExame?.toUpperCase()}
        </>
      )}
      loading={processandoOpcoes}
      loadingText="Carregando..."
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          value={inputExame}
          onChange={(e) => handleChangeInputExame(e.target.value)}
        />
      )}
    />
  )
}
